/**
 * 地址类
 */
export default class Address {
  constructor(address = {}) {
    this.id = address.empAddrId
    this.empAddrId = address.empAddrId
    this.recipient = address.recipient
    this.cName = address.cName
    this.city = address.city
    this.cityName = address.cityName
    this.province = address.province
    this.isDefault = address.isDefault == 1 ? true : false
    this.phoneNumber = address.phoneNumber
    this.addr = address.addr
    this.post = address.post
  }
}